import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { FC } from 'react';

export const LayoutSpinner: FC = () => {
    return (
        <Spin
            indicator={<LoadingOutlined spin />}
            size="large"
            style={{
                width: '100%',
                height: '100%',
                display: 'grid',
                placeItems: 'center',
            }}
            spinning
        />
    );
};
